import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';

export interface ValetDamageCheckCoordinate {
  Id: number;
  X: number;
  Y: number;
  Type: number;
  Timestamp: string;
  TimestampLocal?: string;
  TimestampLocalFriendlyString?: string;
}

/** Input contract callers pass to SimpleModalService.addModal for this modal. */
export interface ValetDamageCheckModalInput {
  ModalTitle: string;
  MediaId: string | number;
  DamageCheckCoordinates: ValetDamageCheckCoordinate[];
}

@Component({
  selector: 'app-valet-damage-check-modal',
  templateUrl: './valet-damage-check-modal.component.html',
  styleUrls: ['./valet-damage-check-modal.component.scss'],
  standalone: false
})
export class ValetDamageCheckModalComponent extends SimpleModalComponent<ValetDamageCheckModalInput, void> implements ValetDamageCheckModalInput, OnInit, AfterViewInit, OnDestroy {
  ModalTitle: string = '';
  MediaId: string | number = '';
  DamageCheckCoordinates: ValetDamageCheckCoordinate[] = [];

  public dotSizePx: number = 14;
  public markersVisible: boolean = true;

  @ViewChild('imageWrapper', { static: false }) imageWrapper!: ElementRef<HTMLDivElement>;
  @ViewChild('modalCard', { static: false }) modalCard!: ElementRef<HTMLDivElement>;
  private resizeObserver?: ResizeObserver;
  //element that was focused before the dialog opened, so focus can be restored on close
  private previouslyFocusedElement?: HTMLElement;

  constructor(private zone: NgZone) {
    super();
  }

  ngOnInit(): void {
    this.previouslyFocusedElement = document.activeElement as HTMLElement ?? undefined;
  }

  typeName(type: number): string {
    switch (type) {
      case 0: return 'Dent';
      case 1: return 'Scratch';
      case 2: return 'Other';
      //unrecognized future types fall back to the neutral 'Other' styling
      default: return 'Other';
    }
  }

  typeClass(type: number): string {
    return 'damage-' + this.typeName(type).toLowerCase();
  }

  toggleMarkers(): void {
    this.markersVisible = !this.markersVisible;
  }

  ngAfterViewInit(): void {
    this.modalCard?.nativeElement?.focus();

    const el = this.imageWrapper?.nativeElement;
    if (!el || typeof ResizeObserver === 'undefined') {
      return;
    }
    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        const shorterSide = Math.min(width, height);
        if (shorterSide <= 0) {
          continue;
        }
        const next = Math.max(4, shorterSide * 0.06);
        if (Math.abs(next - this.dotSizePx) >= 0.5) {
          this.zone.run(() => { this.dotSizePx = next; });
        }
      }
    });
    this.resizeObserver.observe(el);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.previouslyFocusedElement?.focus();
  }
}
